module.exports = "/_next/static/images/0631703b17bfbe897b14de84d724a9e1-sanpablo-5.jpg";